export interface TileTimesheet {
  order_id: string;
  status: string;
  closed_at: string | null;
  timesheet_items: { hours: number }[];
}

export interface TileOrder {
  id: string;
  hourly_rate: number | null;
}

export interface TileTotals {
  open: number;
  approved: number;
  openEur: number;
  approvedEur: number;
}

/**
 * Aggregates the dashboard tiles: hours and order value (hours multiplied by
 * the hourly rate of the respective order, summed over all orders).
 *
 * Archived LNW (closed_at set) are billed and paid, so they are left out of
 * both tiles entirely. Rejected LNW never count towards either tile.
 */
export const computeTileTotals = (rows: TileTimesheet[], orders: TileOrder[]): TileTotals => {
  const rateById = new Map(orders.map((o) => [o.id, Number(o.hourly_rate ?? 0)]));
  let open = 0;
  let approved = 0;
  let openEur = 0;
  let approvedEur = 0;

  for (const r of rows) {
    if (r.closed_at) continue;
    const sum = r.timesheet_items.reduce((acc, i) => acc + Number(i.hours), 0);
    const eur = sum * (rateById.get(r.order_id) ?? 0);
    if (r.status === "approved") {
      approved += sum;
      approvedEur += eur;
    } else if (r.status !== "rejected") {
      open += sum;
      openEur += eur;
    }
  }

  return { open, approved, openEur, approvedEur };
};
